/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HousingSite } from '../models/HousingSite';
import type { HousingSiteDto } from '../models/HousingSiteDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class HousingSitesService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all sites in the DB.
     * @param sysOrgGuid The sys org guid to filter the sites by.
     * @returns HousingSiteDto OK
     * @throws ApiError
     */
    public getAllSites(
        sysOrgGuid: string,
    ): CancelablePromise<Array<HousingSiteDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingSites/{sysOrgGuid}/GetAllSites',
            path: {
                'sysOrgGuid': sysOrgGuid,
            },
        });
    }
    /**
     * Get a site by its Guid.
     * @param siteGuid The id of the site.
     * @returns HousingSite OK
     * @throws ApiError
     */
    public getSite(
        siteGuid: string,
    ): CancelablePromise<HousingSite> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/housing/HousingSites/{siteGuid}',
            path: {
                'siteGuid': siteGuid,
            },
        });
    }
    /**
     * Update a site by its guid.
     * @param siteGuid The guid of the site.
     * @param requestBody The updated site.
     * @returns HousingSiteDto OK
     * @throws ApiError
     */
    public updateSite(
        siteGuid: string,
        requestBody?: HousingSiteDto,
    ): CancelablePromise<HousingSiteDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/housing/HousingSites/{siteGuid}',
            path: {
                'siteGuid': siteGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new site.
     * @param requestBody The new site.
     * @returns HousingSiteDto OK
     * @throws ApiError
     */
    public createSite(
        requestBody?: HousingSiteDto,
    ): CancelablePromise<HousingSiteDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/housing/HousingSites',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete a site by its id.
     * @param siteId The id of the site.
     * @returns HousingSite OK
     * @throws ApiError
     */
    public deleteSite(
        siteId: number,
    ): CancelablePromise<HousingSite> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/housing/HousingSites/{siteId}',
            path: {
                'siteId': siteId,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
